import type { RouteRecordRaw } from 'vue-router'

import { routes } from '@app/router/routes'

const META = { requiresAuth: true } as const

export const ordersRoutes: RouteRecordRaw[] = [
  {
    path: routes.ORDERS,
    name: 'orders',
    component: () => import('./OrdersPage.vue'),
    meta: { ...META, title: 'Orders' },
    redirect: routes.ORDERS_PENDING_APPROVAL,
  },
  {
    path: routes.ORDERS_PENDING_APPROVAL,
    name: 'orders.pending-approval',
    component: () => import('./PendingApprovalPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_ALL,
    name: 'orders.all',
    component: () => import('./AllOrdersPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_ALL_DETAIL,
    name: 'orders.all.detail',
    component: () => import('./OrderDetailPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_COMPLETED,
    name: 'orders.completed',
    component: () => import('./CompletedOrdersPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_COMPLETED_DETAIL,
    name: 'orders.completed.detail',
    component: () => import('./CompletedOrderDetailPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_REJECTED,
    name: 'orders.rejected',
    component: () => import('./RejectedCancelledPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_REJECTED_DETAIL,
    name: 'orders.rejected.detail',
    component: () => import('./RejectedOrderDetailPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_VASP_PROCESSING,
    name: 'orders.vasp-processing',
    component: () => import('./VaspProcessingPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
  {
    path: routes.ORDERS_REFUND,
    name: 'orders.refund',
    component: () => import('./RefundOrdersPage.vue'),
    meta: { ...META, activeMenu: 'Orders' },
  },
]
